import {
    Component,
    Injector,
    ViewEncapsulation,
    OnInit,
    OnDestroy,
} from '@angular/core';
import { appModuleAnimation } from '@axilla/axilla-shared';
import { AppComponentBase } from '@shared/common/app-component-base';

import {Subject} from '@node_modules/rxjs';

import {FieldAgentService} from '@app/webshop/field-agent/shared/services/field-agent.service';
import {ImpersonationService} from '@app/admin/users/impersonation.service';
import {Router} from '@angular/router';
import {FieldAgentOrderService} from '@app/webshop/field-agent/shared/services/field-agent-order.service';

@Component({
    templateUrl: './field-agent-order-submitted.component.html',
    styleUrls: ['./field-agent-order-submitted.component.less'],
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()]
})
export class FieldAgentOrderSubmittedComponent extends AppComponentBase implements OnInit, OnDestroy {

    protected readonly destroy$ = new Subject<void>(); // Used to signal unsubscription

    private fieldAgentDashboard = '/app/webshop/field-agent/select-templates';

    constructor(
        injector: Injector,
        private _fieldAgentOrderService: FieldAgentOrderService,
        private _impersonationService: ImpersonationService,
        private _router: Router
    ) {
        super(injector);
    }

    ngOnInit() {

    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    backToMyAccount(): void {
        this._fieldAgentOrderService.flush();
        this._impersonationService.backToImpersonator();
    }

    newOrder(): void {
        abp.message.confirm(
            'Do you want to go back to start from the beginning?'
            , 'Start new order'
            , (result: boolean) => {
                if (result) {
                    this._fieldAgentOrderService.flush();
                    this._router.navigate([this.fieldAgentDashboard]);
                }
            }
            , {
                showCloseButton: true,
                customClass: {
                    container: 'modal-like'
                }
            });
    }
}
